import React, { useCallback } from 'react';
import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { useHistory } from 'react-router';
import Tab, { TabGroup } from '@amzn/meridian/tab';

export const Header = ({ workflowData, currentPage }) => {
  const history = useHistory();

  const handleTabChanged = useCallback(
    value => {
      history.push(`/workflows/${workflowData.workflowId}/${value}`);
    },
    [history, workflowData]
  );

  return (
    <Row className="mb-4" width="99%" widths={['fill', 'fit']} wrap="down">
      <div>
        <Heading level={1}>{workflowData ? workflowData.workflowName : ''}</Heading>
        <Text color="secondary">{workflowData ? workflowData.workflowId : ''}</Text>
      </div>
      <div>
        <TabGroup value={currentPage} onChange={handleTabChanged}>
          <Tab value="edit">Build</Tab>
          <Tab value="live">Production</Tab>
          <Tab value="test">Test</Tab>
          <Tab value="history">History</Tab>
        </TabGroup>
      </div>
    </Row>
  );
};
